import DateTime from "./DateTime";

/**
 * Time
 *
 * This module contains utility methods for "modulo time", which is a time that is unassociated with any date.
 *
 * Datetime: January 1, 2001, 9:00 AM
 * Modulo time: 9:00 AM
 */
const Time = {
  formattedDays,
  to12Hour,
  to12HourShort,
  to24Hour,
};

function to24Hour(twelveHourModuloTimeString) {
  if (!twelveHourModuloTimeString) {
    return twelveHourModuloTimeString;
  }

  return DateTime.format(new Date(`2000-01-01 ${twelveHourModuloTimeString}`), "HH:mm");
}

function to12Hour(twentyFourHourModuloTimeString) {
  if (!twentyFourHourModuloTimeString) {
    return twentyFourHourModuloTimeString;
  }

  return DateTime.format(new Date(`2000-01-01 ${twentyFourHourModuloTimeString}`), "h:mm A");
}

function to12HourShort(timeString) {
  if (timeString.endsWith(":00")) {
    return DateTime.format(`2000-01-01T${timeString}`, "h A");
  }
  return DateTime.format(`2000-01-01T${timeString}`, "h:mm A");
}

function displayNameForDay(day) {
  const map = {
    friday: "Fri",
    monday: "Mon",
    saturday: "Sat",
    sunday: "Sun",
    thursday: "Thu",
    tuesday: "Tue",
    wednesday: "Wed",
  };

  return map[day];
}

function groupConsecutiveDays(days) {
  const grouped = [];
  let tempGroup = [days[0]];

  for (let i = 1; i < days.length; i++) {
    if (DateTime.DAYS_OF_WEEK.indexOf(days[i]) === DateTime.DAYS_OF_WEEK.indexOf(days[i - 1]) + 1) {
      tempGroup.push(days[i]);
    } else {
      grouped.push(tempGroup);
      tempGroup = [days[i]];
    }
  }
  grouped.push(tempGroup);

  return grouped
    .map((group) => {
      if (group.length >= 3) {
        return `${displayNameForDay(group[0])}-${displayNameForDay(group[group.length - 1])}`;
      }

      return group.map(displayNameForDay).join(", ");
    })
    .join(", ");
}

function formattedDays(recurringEvent) {
  const days = [];
  DateTime.DAYS_OF_WEEK.forEach((day) => {
    if (recurringEvent[day] === true) {
      days.push(day);
    }
  });

  return groupConsecutiveDays(days);
}

export default Time;
